import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { zh as sysZh, en as sysEn } from './systemManagement'
import { zh as commonZh, en as commonEn } from './common'
import { zh as elZh, en as elEn } from './elementUI'
import { zh as navZh, en as navEn } from './navigation'
import { zh as baseZh, en as baseEn } from './baseData'
import { zh as applyZh, en as applyEn } from './apply'
import { zh as visitPlanZh, en as visitPlanEn } from './visitPlan'
import quoteByLine from "./quoteByLine"
import storeFeedback from "@/components/common/i18n/storeFeedback"
import quote from "@/components/common/i18n/quote";
import taskList from "@/components/common/i18n/taskList";
import sensory from "@/components/common/i18n/sensory";
import supplierManage from "@/components/common/i18n/supplierManage/supplierManage";
import settlementUnit from "@/components/common/i18n/settlementUnit/settlementUnit";
import system from "@/components/common/i18n/system";
import ssrManage from "@/components/common/i18n/ssrManage";
import capacity from "@/components/common/i18n/capacity/capacity";
import BC from "@/components/common/i18n/BCManage/BC";
import DC from "@/components/common/i18n/DC/DC";
import rfpManage from "@/components/common/i18n/rfpManage";
import fpaManage from "@/components/common/i18n/fpaManage";
import spm from "@/components/common/i18n/spm";
import material from "@/components/common/i18n/material";

Vue.use(VueI18n)

let ZH = {
    sys: sysZh,
    common: commonZh,
    taskList: taskList.zh,
    el: elZh,
    nav: navZh,
    base: baseZh,
    quoteByLine: quoteByLine.zh,
    quote: quote.zh,
    storeFeedback: storeFeedback.zh,
    visitPlan: visitPlanZh,
    apply: applyZh,
    sensory: sensory.zh,
    supplierManage: supplierManage.zh,
    settlementUnit: settlementUnit.zh,
    ssrManage: ssrManage.zh,
    capacity: capacity.zh,
    BC: BC.zh,
    system: system.zh,
    DC: DC.zh,
    rfpManage: rfpManage.zh,
    fpaManage: fpaManage.zh,
    spm: spm.zh,
    material: material.zh,
}

let EN = {
    sys: sysEn,
    common: commonEn,
    taskList: taskList.en,
    el: elEn,
    nav: navEn,
    base: baseEn,
    quoteByLine: quoteByLine.en,
    quote: quote.en,
    storeFeedback: storeFeedback.en,
    visitPlan: visitPlanEn,
    apply: applyEn,
    sensory: sensory.en,
    supplierManage: supplierManage.en,
    settlementUnit: settlementUnit.en,
    system: system.en,
    ssrManage: ssrManage.en,
    fpaManage: fpaManage.en,
    capacity: capacity.en,
    BC: BC.zh,
    DC: DC.zh,
    rfpManage: rfpManage.zh,
    spm: spm.zh,
    material: material.zh,
}

const i18n = new VueI18n({
    locale: 'zh-CN',
    messages: {
        'zh-CN': ZH,
        'en-US': EN
    }
})
export default i18n